import { Video } from '../types';
import { formatViewCount } from '../utils/format';

export function RankingShareCard({ video, context }: { video: Video; context: string }) {
  return (
    <aside className="ranking-share-card" aria-label={`Number one ${context}`}>
      <img src={video.thumbnail || '/og-image.png'} alt="" />
      <div className="ranking-share-copy">
        <span className="ranking-share-kicker">#1 {context}</span>
        <strong>{video.title}</strong>
        <span>{video.channelTitle} · {formatViewCount(video.viewCount)} views</span>
      </div>
      <span className="ranking-share-brand">YouTubeMost</span>
    </aside>
  );
}
